import { render, staticRenderFns } from "./TransactionVolumeChartSchool.vue?vue&type=template&id=3088decd&scoped=true"
import script from "./TransactionVolumeChartSchool.vue?vue&type=script&lang=js"
export * from "./TransactionVolumeChartSchool.vue?vue&type=script&lang=js"
import style0 from "./TransactionVolumeChartSchool.vue?vue&type=style&index=0&id=3088decd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3088decd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3088decd')) {
      api.createRecord('3088decd', component.options)
    } else {
      api.reload('3088decd', component.options)
    }
    module.hot.accept("./TransactionVolumeChartSchool.vue?vue&type=template&id=3088decd&scoped=true", function () {
      api.rerender('3088decd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/TransactionVolumeChartSchool.vue"
export default component.exports